import gql from 'graphql-tag';

export const FETCH_CLEAN_KWHS_QUERY = gql`
  query FetchCleanKwhs($planId: Int!) {
    plan(id: $planId) {
      id
      cleanKilowattHours {
        id
        startDate
        endDate
        kwh
        totalRecsPurchased
        carbonEquivalency {
          totalCarbon
        }
        productSubscription {
          id
          product {
            id
            key
          }
        }
        featuredWindProject {
          id
          name
          imageUrl
          location
          projectType
          state
        }
      }
    }
  }
`;

export const fetchCleanKwhsMock = {
  plan: {
    cleanKilowattHours: [
      {
        carbonEquivalency: {
          totalCarbon: 9,
        },
        endDate: '2021-03-18',
        featuredWindProject: {
          id: 1,
          imageUrl: 'https://myimageurl',
          location: 'Goldendale',
          name: 'Goodnoe Hills',
          projectType: 'wind',
          state: 'WA',
        },
        id: 10,
        kwh: 90,
        productSubscription: {
          id: 1000,
          product: {
            id: 2000,
            key: 'usaged_based',
          },
        },
        startDate: '2021-02-22',
        totalRecsPurchased: 19,
      },
      {
        carbonEquivalency: {
          totalCarbon: 10,
        },
        endDate: '2021-02-21',
        featuredWindProject: {
          id: 2,
          imageUrl: 'https://myimageurl',
          location: 'Gilliam',
          name: 'Leaning Juniper 1',
          projectType: 'wind',
          state: 'OR',
        },
        id: 11,
        kwh: 100,
        productSubscription: {
          id: 3000,
          product: {
            id: 4000,
            key: 'utility_average',
          },
        },
        startDate: '2021-02-01',
        totalRecsPurchased: 20,
      },
      {
        carbonEquivalency: {
          totalCarbon: 11,
        },
        endDate: '2021-01-31',
        featuredWindProject: {
          id: 3,
          imageUrl: 'https://myimageurl',
          location: 'Groton',
          name: 'Day County',
          projectType: 'wind',
          state: 'SD',
        },
        id: 12,
        kwh: 110,
        productSubscription: {
          id: 5000,
          product: {
            id: 6000,
            key: 'utility_average',
          },
        },
        startDate: '2021-01-01',
        totalRecsPurchased: 21,
      },
    ],
    id: 1,
  },
};
